<template>
	<div style="display: flex;">
		<div
			class="viewport"
			@mousedown="onMouseDown"
			@mouseup="onMouseUp"
			@mousemove="onMouseMove"
			:style="{ width: vw + 'px', height: vh + 'px' }"
			ref="view"
		>
			<template v-for="(l, i) in layers">
				<div
					class="view-layer bg"
					:class="{ selected: isSelected(i) }"
					:key="l.id"
					v-if="l.type === 'bg'"
					@mousedown="selectLayer(i)"
					:style="{
						background: l.data.color,
						left: l.left + '%',
						top: l.top + '%',
					}"
				/>
				<div
					class="view-layer image"
					:class="{ selected: isSelected(i) }"
					:key="l.id"
					v-if="l.type === 'image'"
					@mousedown="selectLayer(i)"
					:style="{
						backgroundImage: l.data.image,
						left: l.left + '%',
						top: l.top + '%',
					}"
				/>
				<div
					class="view-layer text"
					:class="{ selected: isSelected(i) }"
					:key="l.id"
					v-if="l.type === 'text'"
					@mousedown="selectLayer(i)"
					:style="{
						color: l.data.color,
						fontSize: l.data.fontSize,
						fontWeight: l.data.fontWeight,
						width: l.data.width,
						left: l.left + '%',
						top: l.top + '%',
					}"
				>
					<div class="resizer">
						<div class="text">
							{{ l.data.text }}
						</div>
						<div class="r-left" />
						<div class="r-right" />
					</div>
				</div>
			</template>
		</div>

		<div class="settings" v-if="curLayer">
			<div v-if="curLayer.type === 'text'">
				<uiBlockTitle>Текст</uiBlockTitle>
				<textarea v-model="curLayer.data.text" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'StoryView',
	props: {
		layers: Array,
		vw: {
			type: [String, Number],
			default: 300,
		},
		vh: {
			type: [String, Number],
			default: 600,
		},
	},
	data() {
		return {
			curLayerIndex: null,
		}
	},
	computed: {
		layerSelected() {
			return this.curLayerIndex !== null
		},
		curLayer() {
			return this.layers[this.curLayerIndex]
		},
	},
	methods: {
		isSelected(i) {
			return i === this.curLayerIndex
		},
		selectLayer(i) {
			this.curLayerIndex = i
		},
		onMouseDown(e) {
			if (!this.layerSelected) return
			this.dragging = true
			this.viewBounds = this.$refs.view.getBoundingClientRect()
			this.mouseOffsetX = e.offsetX
			this.mouseOffsetY = e.offsetY
		},
		onMouseMove(e) {
			if (!this.dragging) return
			if (!['text', 'button'].includes(this.curLayer.type)) return
			this.moveLayer(e)
		},
		onMouseUp(e) {
			this.dragging = false
			this.mouseOffsetX = 0
			this.mouseOffsetY = 0
			// console.log(e)
		},
		moveLayer(e) {
			let x = e.clientX - this.viewBounds.left - this.mouseOffsetX
			let y = e.clientY - this.viewBounds.top - this.mouseOffsetY
			this.layers[this.curLayerIndex].left = (x / this.vw) * 100
			this.layers[this.curLayerIndex].top = (y / this.vh) * 100
		},
		sizeLayer(e) {},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.viewport {
	background: @grey;
	overflow: hidden;
	border-radius: 16px;
	position: relative;
	flex-shrink: 0;

	.view-layer {
		width: fit-content;
		height: fit-content;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
		user-select: none;

		&.bg {
			width: 100%;
			height: 100%;
		}

		&.image {
			background-size: cover;
			background-position: center;
		}
	}

	.view-layer.selected {
		outline: 2px solid @accent;

		.r-left,
		.r-right {
			display: block;
		}
	}

	.resizer {
		width: 100%;
		height: 100%;
		position: relative;

		.r-left {
			width: 10px;
			height: 10px;
			background: @accent;
			border-radius: 50%;
			position: absolute;
			top: 50%;
			left: -6px;
			margin-top: -6px;
			cursor: ew-resize;
			display: none;
		}

		.r-right {
			width: 12px;
			height: 12px;
			background: @accent;
			border-radius: 50%;
			position: absolute;
			top: 50%;
			right: -6px;
			margin-top: -6px;
			cursor: ew-resize;
			display: none;
		}
	}
}

.settings {
	width: 200px;
	margin-left: 20px;
	background: @grey;
	flex-shrink: 0;
}
</style>
